import "./Home.module.css";
import SiteNavigation from "@/reusable_sections/Header";
import TheSilkStrandSignature from "./sections/TheSilkStrandSignature";
import OurServicesOverview from "./sections/OurServicesOverview";
import OurDigitalCraft from "./sections/OurDigitalCraft";
import ReserveYourTime from "./sections/ReserveYourTime";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <SiteNavigation />
      <TheSilkStrandSignature />
      <OurServicesOverview />
      <OurDigitalCraft />
      <ReserveYourTime />
      <Footer />
    </div>;
}